module.exports = __webpack_public_path__ + "static/media/documentation.8dc2170d.md";